import React from 'react'

import { BeatLoader } from 'react-spinners'

import styles from './styles.module.scss'

type ButtonProps = {
  title: string
  loading?: boolean
  onClick?: () => void
}

export const Button = ({ loading, title, onClick }: ButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className={styles.button}
    >
      {loading ? <BeatLoader color="#FFF" size={8} /> : <span>{title}</span>}
    </button>
  )
}
